<template>
  <div class="user_wrap">
    <div class="user_title">
      <span>用户{{taskChildData.targetName}}情况</span>
      <el-button size="mini" @click="toImg('uset_pic', `用户${taskChildData.targetName}情况`, taskChildData.taskName)" :disabled="Object.keys(userCover).length === 0">下载图片</el-button>
    </div>
    <div class="user_people">实际发券<span>{{userCover.actualCouponNum | isNullOr0}}</span>人，核销{{formTag.form1 || '-'}}<span>{{userCover.couponConsumeNum  | isNullOr0}}</span>人，30天内有{{formTag.form2  || '-'}}<span>{{userCover.consumeNum30  | isNullOr0}}</span>人</div>
    <div class="user_time">统计时间：{{taskChildData.startTimeFormat || '-'}}至{{moment(taskChildData.endTimeFormat).add(30, 'days').format('YYYY-MM-DD') || '-'}}<span v-if="taskChildData.status === 4">(持续更新中)</span></div>
    <div class="uset_pic" id="uset_pic">
      <template v-if="Object.keys(userCover).length > 0">
        <div class="pic_left">
          <div class="first">
            <div class="f_title">
              <span>画像人群总和</span>
              <span>{{userCover.crowdNum | isNullOr0}}人</span>
            </div>
          </div>
          <div class="sec">
            <div class="f_title">
              <span>实际发券</span>
              <span>{{userCover.actualCouponNum | isNullOr0}}人</span>
            </div>
          </div>
          <div class="third">
            <div class="f_title">
              <span>券核销{{formTag.form3}}</span>
              <span>{{userCover.couponConsumeNum | isNullOr0}}人</span>
            </div>
          </div>
          <div class="four">
            <div class="f_title">
              <span>30天{{formTag.form5 || '-'}}</span>
              <span>{{userCover.consumeNum30 | isNullOr0}}人</span>
            </div>
          </div>
          <div class="arrow_first"><span></span><img src="../../../../assets/image/three.png" alt=""></div>
          <div class="arrow_sec"><span></span><img src="../../../../assets/image/three.png" alt=""></div>
          <div class="arrow_third"><span></span><img src="../../../../assets/image/three.png" alt=""></div>
        </div>
        <div class="pic_right">
          <div class="ri_first">
            <span>营销覆盖率 {{userCover.coverageRate || '-'}}
              <el-popover
                class="pop"
                style="width: 100%"
                placement="top"
                trigger="hover">
                <div class="pop-container">
                  <div>覆盖率为第二层/第一层</div>
                  <div>比本站均值计算逻辑：本次活动覆盖率/{（历史和当前本站同类型覆盖率）/历史和当前同类型活动次数}</div>
                  <div>比历史均值计算逻辑：本次活动覆盖率/{（历史和当前全部同类型覆盖率）/历史和当前同类型活动次数}</div>
                </div>
                <span class="que" slot="reference">?</span>
              </el-popover>
            </span>
            <span :class="[userCover.gasCoverageAvg && userCover.gasCoverageAvg.split('')[0] > 0 ? 'red' : 'green']">比本站均值 {{userCover.gasCoverageAvg | isPos}}</span>
            <span :class="[userCover.allCoverageAvg && userCover.allCoverageAvg.split('')[0] > 0 ? 'red' : 'green']">比周边均值 {{userCover.allCoverageAvg | isPos}}</span>
          </div>
          <div class="ri_sec">
            <span>核销{{formTag.form4}}率 {{userCover.couponConsumeRate || '-'}}
              <el-popover
                class="pop"
                style="width: 100%"
                placement="top"
                trigger="hover">
                <div class="pop-container">
                  <div>核销率为第三层/第二层</div>
                  <div>比本站均值计算逻辑：本次活动核销率/{（历史和当前本站同类型核销率）/历史和当前同类型活动次数}</div>
                  <div>比历史均值计算逻辑：本次活动核销率/{（历史和当前全部同类型核销率）/历史和当前同类型活动次数}</div>
                </div>
                <span class="que" slot="reference">?</span>
              </el-popover>
            </span>
            <span :class="[userCover.gasCouponConsumeAvg && userCover.gasCouponConsumeAvg.split('')[0] > 0 ? 'red' : 'green']">比本站均值 {{userCover.gasCouponConsumeAvg | isPos}}</span>
            <span :class="[userCover.allCouponConsumeAvg && userCover.allCouponConsumeAvg.split('')[0] > 0 ? 'red' : 'green']">比周边均值 {{userCover.allCouponConsumeAvg | isPos}}</span>
          </div>
          <div class="ri_third">
            <span>30天{{formTag.form6 || '-'}}率 {{userCover.gas30ConsumeRate || '-'}}
              <el-popover
              class="pop"
              style="width: 100%"
              placement="top"
              trigger="hover">
              <div class="pop-container">
                <div>复购率为第四层/第三层</div>
                <div>比本站均值计算逻辑：本次活动复购率/{（历史和当前本站同类型复购率）/历史和当前同类型活动次数}</div>
                <div>比历史均值计算逻辑：本次活动复购率/{（历史和当前全部同类型复购率）/历史和当前同类型活动次数}</div>
              </div>
              <span class="que" slot="reference">?</span>
            </el-popover>
            </span>
            <span :class="[userCover.gas30ConsumeAvg && userCover.gas30ConsumeAvg.split('')[0] > 0 ? 'red' : 'green']">比本站均值 {{userCover.gas30ConsumeAvg | isPos}}</span>
            <span :class="[userCover.all30ConsumeAvg && userCover.all30ConsumeAvg.split('')[0] > 0 ? 'red' : 'green']">比周边均值 {{userCover.all30ConsumeAvg | isPos}}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <noDataPic/>
      </template>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import noDataPic from './noDataPic'
import mixinDown from './mixin'
export default {
  mixins: [mixinDown],
  props: {
    userCover: {
      type: Object,
      default: () => {}
    },
    taskChildData: {
      type: Object
    }
  },
  data () {
    return {
      formTag: {}
    }
  },
  watch: {
    taskChildData: {
      handler (val) {
        switch (val.targetName) {
          case '复购':
            this.formTag = { form1: '复购', form2: '二次复购', form3: '复购', form4: '复购', form5: '复购', form6: '复购' }
            break
          case '转化':
            this.formTag = { form1: '转化', form2: '复购', form3: '转化', form4: '转化', form5: '复购', form6: '复购' }
            break
          case '召回':
            this.formTag = { form1: '转化', form2: '复购', form3: '召回', form4: '召回', form5: '复购', form6: '复购' }
            break
          case '提频':
            this.formTag = { form1: '核销', form2: '消费频次', form3: '', form4: '', form5: '提额', form6: '提额' }
            break
          case '巩固':
            this.formTag = { form1: '复购', form2: '消费留存', form3: '转化', form4: '转化', form5: '复购', form6: '复购' }
            break 
        }
      },
      immediate: true
    }
  },
  components: {
    noDataPic
  },
  methods: {
    moment
  }
}
</script>
<style scoped lang="less">
.user_wrap{
  padding: 16px;
}
.user_title{
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  >span{
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
  }
  .user_btn{
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #C0C4CC;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
.user_people{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  >span{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3377FF ;
  }
}
.user_time{
  margin-top: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.uset_pic{
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  .pic_left{
    position: relative;
    width: 210px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    .first{
      border-top: 90px solid #3377FF;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      height: 0;
      width: 180px;
      .f_title{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        position: absolute;
        z-index: 90;
        top: 10%;
        left: 30%;
      }
    }
    .sec{
      margin-top: 4px;
      border-top: 80px solid #FFAC52;
      border-left: 14px solid transparent;
      border-right: 14px solid transparent;
      height: 0;
      width: 153px;
      .f_title{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        position: absolute;
        z-index: 90;
        top: 38%;
        left: 35%;
      }
    }
    .third{
      margin-top: 4px;
      border-top: 70px solid #ADCD40;
      border-left: 14px solid transparent;
      border-right: 14px solid transparent;
      height: 0;
      width: 130px;
      .f_title{
        width: 78px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        position: absolute;
        z-index: 90;
        top: 64%;
        left: 32%;
      }
    }
    .four{
      margin-top: 4px;
      border-top: 60px solid #FF5D5D;
      border-left: 14px solid transparent;
      border-right: 14px solid transparent;
      height: 0;
      width: 106px;
      .f_title{
        width: 90px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        position: absolute;
        z-index: 90;
        top: 86%;
        left: 27%;
      }
    }
    .arrow_first{
      position: absolute;
      top: 28%;
      left: 78%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      >span{
        width: 40px;
        height: 1px;
        border: 1px dashed #979797;
      }
    }
    .arrow_sec{
      position: absolute;
      top: 54.7%;
      // left: 163px;
      left: 75%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      >span{
        width: 50px;
        height: 1px;
        border: 1px dashed #979797;
      }
    }
    .arrow_third{
      top: 78.5%;
      // left: 154px;
      left: 71%;
      position: absolute;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      >span{
        width: 60px;
        height: 1px;
        border: 1px dashed #979797;
      }
    }
  }
  .pic_right{
    width: 156px;
    height: 364px;
    >div{
      display: flex;
      flex-direction: column;
      >span:nth-child(1){
        font-size: 13px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      .red{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #F5222D;
      }
      .green{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #48C672;
      }
    }
    .ri_first{
      margin-top: 103px;
      >span{
        margin-top: 4px;
      }
    }
    .ri_sec{
      margin-top: 27px;
       >span{
        margin-top: 4px;
      }
    }
    .ri_third{
      margin-top: 20px;
       >span{
        margin-top: 4px;
      }
    }
    .que{
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-left: 5px;
      border-radius: 50%;
      text-align: center;
      line-height: 15px;
      border: 1px solid #C7C7C7;
      font-size: 14px;
      color: #C7C7C7;
      cursor: pointer;
    }
  }
}
</style>